import SVG from 'react-inlinesvg';
import styled from 'styled-components';
import CTA from '../cta';

export const Card = styled.div`
  position: relative;
  display: inline-flex;
  margin-bottom: ${({ theme }) => theme.spacing.standard};
  box-shadow: ${({ theme }) => theme.boxshadow.small};

  &:hover {
    cursor: pointer;
    box-shadow: ${({ theme }) => theme.boxshadow.standard};
  }
`;

export const CardInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-basis: 100%;
  height: 100%;
  padding: ${({ theme }) =>
    `${theme.spacing.xlarge} ${theme.spacing.standard} ${theme.spacing.standard}`};
`;

export const SVGWrapper = styled.div`
  display: inline-block;
  width: 64px;
  height: 64px;
`;

export const CardSVG = styled(SVG)`
  fill: ${({ theme }) => theme.palette.standardText};
  width: 64px;
  height: 64px;
`;

export const TitleText = styled.h2`
  font-size: ${({ theme }) => theme.fontsize.h3};
  margin-top: ${({ theme }) => theme.spacing.standard};
  margin-bottom: ${({ theme }) => theme.spacing.standard};
  text-align: center;
  width: 100%;
`;

export const SubText = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.standard};
  text-align: ${({ $leftAlignContent }) =>
    $leftAlignContent ? 'left' : 'center'};
`;

export const StyledCardCTA = styled(CTA)`
  margin-top: auto;
  z-index: 1;
`;
